import React from 'react';
import { t } from '../../lang';

import './HistoryPlaceholder.scss';

const HistoryPlaceholder = () => {
	return <div className='HistoryPlaceholder'>{t('There are no transactions yet')}</div>;
};

export default HistoryPlaceholder;
